import gql from 'graphql-tag';

export const UserAvatarDataQuery = gql`
	query UserAvatarDataQuery {
		searchUser(cql: "type=user", first: 100) {
			nodes {
				user {
					accountId
					accountType
					displayName
					profilePicture {
						path
					}
				}
			}
		}
	}
`;
